/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cr_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cron Expression Explainer — Crontab in Plain English | Toolverse`)
};

const es_cr_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explicador de Expresiones Cron — Crontab en Lenguaje Plano | Toolverse`)
};

const de_cr_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cron-Ausdruck-Erklärer — Crontab einfach erklärt | Toolverse`)
};

const nl_cr_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cron-expressieverklaarder — Crontab in eenvoudig Nederlands | Toolverse`)
};

const fr_cr_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explication d'expressions cron — Crontab en langage courant | Toolverse`)
};

const it_cr_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spiegatore di Espressioni Cron — Crontab in Italiano Semplice | Toolverse`)
};

const pt_br2_cr_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explicador de Expressões Cron — Crontab em Linguagem Clara | Toolverse`)
};

const pt_cr_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explicador de Expressões Cron — Crontab em Português Claro | Toolverse`)
};

const ja_cr_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cron式エクスプレーナー — Crontabをわかりやすく | Toolverse`)
};

const zh_cr_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cron 表达式解释器 — 用通俗语言解读 Crontab | Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cr_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cr_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cr_meta_title", locale)
	if (locale === "en") return en_cr_meta_title(inputs)
	if (locale === "es") return es_cr_meta_title(inputs)
	if (locale === "de") return de_cr_meta_title(inputs)
	if (locale === "nl") return nl_cr_meta_title(inputs)
	if (locale === "fr") return fr_cr_meta_title(inputs)
	if (locale === "it") return it_cr_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_cr_meta_title(inputs)
	if (locale === "pt") return pt_cr_meta_title(inputs)
	if (locale === "ja") return ja_cr_meta_title(inputs)
	return zh_cr_meta_title(inputs)
};